export enum CLIENTS_PERMISSIONS {
  CLIENTS_VIEW = 'CRM_USER_VIEW',
  CLIENTS_WRITE = 'USER_ADMINWRITE',
  CRM_USER_EXPORT = 'CRM_USER_EXPORT',
}
